var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef, useMemo } from 'react';
import MUIInputAdornment from '@mui/material/InputAdornment';
import MUITextField from '@mui/material/TextField';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function (theme) {
    var _a, _b;
    return ({
        root: (_a = {},
            _a['& legend'] = {
                background: 'white',
                visibility: 'visible',
            },
            _a['& label'] = (_b = {
                    lineHeight: 1,
                    color: theme.palette.grey[400]
                },
                _b['&[data-shrink="true"]'] = {
                    lineHeight: 1.5,
                },
                _b['&.Mui-focused'] = {
                    color: theme.palette.primary.main,
                },
                _b),
            _a['&:hover label[data-shrink="true"]'] = {
                color: theme.palette.primary.main,
            },
            _a),
    });
};
export var TextField = forwardRef(function (props, ref) {
    var unit = props.unit, error = props.error, name = props.name, id = props.id, InputProps = props.InputProps;
    var cs = useEmotionStyles(styles);
    var extendedInputProps = useMemo(function () { return (__assign({ endAdornment: unit ? (React.createElement(MUIInputAdornment, { position: "end" },
            React.createElement("span", null, unit))) : null }, InputProps)); }, [unit, InputProps]);
    return (React.createElement(MUITextField, __assign({}, props, { className: "".concat(cs.root, " ").concat(props.className), inputRef: ref, InputProps: extendedInputProps, id: id || name, variant: "outlined", fullWidth: true, value: props.value || '', error: !!error })));
});
TextField.displayName = 'TextField';
export default TextField;
